import { cn } from "@workspace/ui/lib/utils";

const NEW_LAUNCH_GRADIENT =
  "linear-gradient(15deg, #FA5627 0%, #FA5627 28%, #FF9C40 100%)";

export type NewLaunchTagProps = {
  className?: string;
  size?: "default" | "compact";
};

export function NewLaunchTag({
  className,
  size = "default",
}: NewLaunchTagProps) {
  return (
    <div
      className={cn(
        "inline-flex items-center justify-center rounded-[6px] text-white",
        size === "compact" ? "px-[7px] py-[4px]" : "px-[7px] py-[4px]",
        className,
      )}
      style={{ background: NEW_LAUNCH_GRADIENT }}
    >
      <span className="captitle-12 whitespace-nowrap uppercase tracking-[0.02em]">
        New launch
      </span>
    </div>
  );
}

const SALE_TEXT_GRADIENT =
  "linear-gradient(89.93deg, #3B7EFF 13.14%, #FF0004 99.94%)";

export function SaleNewLaunchTag() {
  return (
    <div className="inline-flex items-center justify-center rounded-[6px] bg-white px-[7px] pb-[5px] pt-[4px]">
      <span
        className="captitle-12 whitespace-nowrap uppercase tracking-[0.02em]"
        style={{
          background: SALE_TEXT_GRADIENT,
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          backgroundClip: "text",
        }}
      >
        New launch
      </span>
    </div>
  );
}

export const SaleNewLaunchTagMobile = SaleNewLaunchTag;
export const SaleNewLaunchTagDesktop = SaleNewLaunchTag;
